// Safe number formatting utilities
export const safeToFixed = (value: unknown, digits: number = 2): string => {
  if (typeof value !== 'number' || isNaN(value) || !isFinite(value)) {
    return 'N/A';
  }
  return value.toFixed(digits);
};

export const safeNumber = (value: unknown, defaultValue: number = 0): number => {
  if (typeof value === 'number' && !isNaN(value) && isFinite(value)) {
    return value;
  }
  return defaultValue;
};

export const formatCurrency = (amount: unknown): string => {
  const safeAmount = safeNumber(amount, 0);
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(safeAmount);
};

export const formatCurrencyWithCents = (amount: unknown): string => {
  const safeAmount = safeNumber(amount, 0);
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(safeAmount);
};

export const formatPercentage = (value: unknown, digits: number = 2): string => {
  const safeValue = safeNumber(value, 0);
  return `${safeValue.toFixed(digits)}%`;
};

export const formatNumber = (value: unknown): string => {
  const safeValue = safeNumber(value, 0);
  return safeValue.toLocaleString('en-US');
};

export const formatPhoneNumber = (phone: string | null | undefined): string => {
  if (!phone) {
    return '';
  }

  // Remove all non-numeric characters
  const cleaned = phone.replace(/\D/g, '');

  // Handle different lengths
  if (cleaned.length === 10) {
    // Format: (XXX) XXX-XXXX
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  } else if (cleaned.length === 11 && cleaned[0] === '1') {
    // Format: (XXX) XXX-XXXX (strip leading 1)
    return `(${cleaned.slice(1, 4)}) ${cleaned.slice(4, 7)}-${cleaned.slice(7)}`;
  }

  // Return original if format is unexpected
  return phone;
};